import React from 'react';
import { useTranslation } from 'react-i18next';
import { Panel } from '@lib/ui-components';
import { CommuneServicesDataTable } from './commune-services.data-table';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ResourceQueryService } from '@lib/common-sdk';
import { CommuneModel } from '@lib/api-interface';
import { QueryResultRenderer } from '../../../../libs/ui-components/components/query-result-renderer';

export const CommuneServicesPage = () => {
  const { t } = useTranslation();
  const pathParams = useParams();

  const communeQuery = useQuery({
    queryKey: ['communes', pathParams['communeId']?.substring(1)],
    queryFn: () => ResourceQueryService.findOne<CommuneModel>(`/api/resource/communes/${parseInt(pathParams['communeId']!, 10)}`),
  });

  return (
    <QueryResultRenderer
      query={communeQuery}
      render={(communeModel) => {
        return (
          <Panel header={`${t('commune')}: ${communeModel.name}`} borderType='raised'>
            <CommuneServicesDataTable communeId={communeModel.id!} />
          </Panel>
        );
      }}
    />
  );
};
